import { Card, type CardProps } from "@mantine/core";
import type { ReactNode } from "react";
import { axioTokens } from "../../theme";

interface ContentCardProps extends CardProps {
  children: ReactNode;
  interactive?: boolean;
}

export function ContentCard({ children, interactive = false, className, style, ...props }: ContentCardProps) {
  return (
    <Card
      withBorder

      padding="lg"
      className={[interactive ? "contentCardInteractive" : undefined, className].filter(Boolean).join(" ") || undefined}
      style={{
        borderColor: axioTokens.border,
        boxShadow: "none",
        ...style,
      }}
      {...props}
    >
      {children}
    </Card>
  );
}
